<mat-toolbar class="customer-itinerary-toolbar mat-elevation-z2" fxLayout="row" fxLayoutAlign="start center">
  <button mat-icon-button (click)="snav.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
  <h3 class="itinerary-title" fxFlex>{{ itinerary.title }}</h3>
  <a mat-icon-button href="{{ itinerary.link.shortUrl }}" target="_blank">
    <mat-icon>file_download</mat-icon>
  </a>
</mat-toolbar>
<mat-sidenav-container class="customer-itinerary-sidenav-container">
  <mat-sidenav #snav [opened]="mobileQuery.matches ? false : true" [mode]="mobileQuery.matches ? 'over' : 'side'"
    class="customer-itinerary-sidenav mat-elevation-z2">
    <div fxLayout="column">
      <mat-selection-list #activeDaysMatSelectionList [(ngModel)]="activeDays">
        <mat-nav-list style="padding-top:0" fxLayout="column" fxFlex>
          <a mat-list-item class="mat-typography" href="{{ itinerary.link.shortUrl }}" target="_blank">
            <mat-icon matListIcon>file_download</mat-icon>
            <h4 mat-line>Scarica il tuo itinerario</h4>
            <p matLine><small>Documento PDF</small></p>
          </a>
          <mat-divider></mat-divider>
          <mat-list-option class="mat-typography" *ngFor="let day of itinerary.days; let i = index" [value]="day">
            <mat-icon matListIcon>place</mat-icon>
            <h4 mat-line>Giorno {{ i + 1 }}</h4>
            <p matLine>
              <small>{{ day.date?.toDate() | date: "d MMMM, EEEE" }}</small>
            </p>
          </mat-list-option>
          <mat-divider></mat-divider>
          <a mat-list-item class="mat-typography" href="javascript:void(0)" (click)="downloadGpx()">
            <mat-icon matListIcon>explore</mat-icon>
            <h4 mat-line>Scarica Mappa</h4>
            <p matLine><small>File in formato GPX</small></p>
          </a>
        </mat-nav-list>
      </mat-selection-list>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="customer-itinerary-sidenav-content">
    <agm-map [fitBounds]="true">
      <ng-container *ngFor="let day of activeDays">
        <app-customer-itinerary-marker [poi]="poi" *ngFor="let poi of filterGeneratedPois(day.pois, true)">
        </app-customer-itinerary-marker>
        <app-customer-itinerary-marker [poi]="poi" [index]="index" *ngFor="
            let poi of filterGeneratedPois(day.pois, false);
            let index = index
          ">
        </app-customer-itinerary-marker>
      </ng-container>
    </agm-map>
  </mat-sidenav-content>
</mat-sidenav-container>